import { render, staticRenderFns } from "./EdunixStore.vue?vue&type=template&id=f1f3c366&scoped=true&"
import script from "./EdunixStore.vue?vue&type=script&lang=js&"
export * from "./EdunixStore.vue?vue&type=script&lang=js&"
import style0 from "./EdunixStore.vue?vue&type=style&index=0&id=f1f3c366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f3c366",
  null
  
)

export default component.exports